export const getMultiGroupType = input => {
  const matches = [
    { keys: ['GTIN', 'REDE'], value: 'produtoRede' },
    { keys: ['GTIN', 'UF'], value: 'produtoUf' },
    { keys: ['GTIN', 'REGIAO'], value: 'produtoRegiao' },
    { keys: ['FABRICANTE', 'UF'], value: 'fabricanteUf' },
    { keys: ['FABRICANTE', 'REGIAO'], value: 'fabricanteRegiao' },
  ];

  return matches.find(({ keys }) => keys.length === input.length && keys.every(k => input.includes(k)))?.value || null;
};
